import type { ReactNode } from 'react'
import React from 'react'
import { getSystemLocale } from '@/utils'
import { LOCAL_ENUM } from '@/constants'
import useFbe from '@/hooks/useFbe'
import styles from './index.module.less'

interface BaseLayoutProps {
  children?: ReactNode | ReactNode[]
}

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { isFbe } = useFbe()
  return (
    <div className={styles['base-layout']}>
      <div className={styles['base-layout-left']}>
        <div
          className={styles['base-layout-left-main']}
          style={{
            backgroundImage: `url(${
              isFbe || getSystemLocale() === LOCAL_ENUM.EN_US
                ? 'https://static.creativebooster.com/ad-web/fbe/register.jpg'
                : 'https://static.creativebooster.com/ad-web/banner.jpg'
            })`,
          }}
        />
      </div>
      <div className={styles['base-layout-right']}>
        <div className={styles['base-layout-right-form']}>{children}</div>
      </div>
    </div>
  )
}
export default BaseLayout
